import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { RuleAssistModel } from "../model/assist.model";

@Injectable({
    providedIn: 'root',
  })
  export class AssistService {
    private _httpClient = inject(HttpClient);
    apiUrl = environment.apiUrl + 'ask-blakey';
    
    // Rule Assist
    ruleAssist(data: RuleAssistModel){
        return this._httpClient.post<unknown>(this.apiUrl, data);
    }
  }